import React from "react";
import { Link } from "react-router-dom";

export default function PromoRetirementBar() {
  return (
    <div className="mt-8 rounded-xl bg-[#003366] text-white">
      <div className="mx-auto max-w-6xl px-4 py-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-base leading-snug">
          <span className="font-semibold">Ever wondered how much you’ll need in retirement?</span>{" "}
          Use our handy calculator to work it out.
        </p>
        <Link
          to="/retirement"
          className="inline-flex w-full sm:w-auto items-center justify-center rounded-lg bg-white/10 px-4 py-2 text-white hover:bg-white/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
        >
          Open the calculator
        </Link>
      </div>
    </div>
  );
}
